<template>
<center>
    <div :class="bannerColor">
        <h3>Welcome to the AGATRS <i>{{websiteEnvironment}}</i> Site.</h3>
    </div>
</center>
</template>

<script>
import {
    CollapseTransition
} from "vue2-transitions";
import {
    BaseNav,
    Modal
} from "@/components";

export default {
    components: {
        CollapseTransition,
        BaseNav,
        Modal,
    },
    data() {
        return {
            bannerColor: 'orange-banner',
        }
    },
    computed: {
        websiteEnvironment() {
            if (window.location.href.includes('agatrsweb')) {
                this.bannerColor = 'orange-banner'
                return  (window.location.host.includes('stage'))?'Stage-Production': 'Production'
            }
            else if (window.location.href.includes('agatrstraining')) {
                this.bannerColor = 'purple-banner'
                return (window.location.host.includes('stage'))?'Stage-Training':  'Training'
            }
            else if (window.location.href.includes('agatrsstage')) {
                this.bannerColor = 'light-blue-banner'
                return 'Staging'
            }  
            else {
                this.bannerColor = 'light-blue-banner'
                return 'Local Development'
            } 
        },
    },
};
</script>

<style scoped>
.orange-banner {
    background-color: orange;
}

.purple-banner {
    background-color: rgb(195, 139, 247);
}

.light-blue-banner {
    background-color: #70b6f7;
}

/* Changes background color of dropdown items */
.center {
    text-align: center;
}
</style>
